module.exports = __webpack_public_path__ + "static/media/shop.22ee2034.svg";